import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    minWidth: 500,
    borderRadius: 12,
  },
  title: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: theme.spacing(2),
  },
  content: {
    padding: theme.spacing(3),
  },
  uploadArea: {
    border: `2px dashed ${theme.palette.primary.main}`,
    borderRadius: 8,
    padding: theme.spacing(4),
    textAlign: 'center',
    marginBottom: theme.spacing(3),
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  uploadIcon: {
    fontSize: 48,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
  fileList: {
    maxHeight: 300,
    overflow: 'auto',
    marginTop: theme.spacing(2),
  },
  fileItem: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  successIcon: {
    color: theme.palette.success.main,
  },
  formField: {
    marginBottom: theme.spacing(2),
  },
}));
